import IconApp from "assets/images/logo_skybet.png";
import { Helmet } from "react-helmet";
type Props = {
  title: string | undefined;
};

function HelmetCustom(props: Props) {
  const { title = "" } = props;
  return (
    <Helmet>
      <title>{title + " - Scatter365"}</title>
      <link rel="icon" type="image/png" href={IconApp} />
    </Helmet>
  );
}

export default HelmetCustom;
